var link_viewer_default = {
  "fontElementMap": "PYfR-",
  "link": "n0rzk",
  "linkInEditor": "_1eG-e",
  "linkInViewer": "c8ryQ",
  "toolbarUrlContainer": "BRcnk",
  "toolbarUrl": "XuK7l",
  "toolbarUrlAnchor": "Yqg7H"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
